import React from 'react'
import VerifyForm from '../../components/VerifyForm'
import Header from '../../components/Header'

const Verify = () => {
    return(
        <React.Fragment>
            <Header />
            <section className="signup-body">
                <section className="centered">
                    <VerifyForm />
                </section>
            </section>
        </React.Fragment>
    )
}

export default Verify
